import v1 from './v1';

export default {
  searchDip(keyword) {
    return v1.get('/search/dip-data', { params: { keyword } });
  },
};
